"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var ngx_bootstrap_1 = require("ngx-bootstrap");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var angular2_text_mask_1 = require("angular2-text-mask");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var trip_details_1 = require("./trip-details");
var type_ahead_1 = require("./type-ahead");
var coverages_1 = require("./coverages");
var masked_datepicker_1 = require("./masked-datepicker");
var traveler_details_1 = require("./traveler-details");
var validation_messages_1 = require("./validation-messages");
var address_1 = require("./address");
var policy_details_1 = require("./policy-details");
var date_pair_1 = require("./date-pair");
var error_message_display_1 = require("./error-message-display");
var misc_1 = require("./misc");
var flight_builder_1 = require("./flight-builder");
var view_config_models_1 = require("./view-config-models");
var view_config_models_2 = require("./view-config-models");
var coverage_cart_1 = require("./coverage-cart");
var custom_directives_1 = require("./custom-directives");
var custom_directives_2 = require("./custom-directives");
var item_selector_1 = require("./item-selector");
var payments_1 = require("./payments");
var form_controls_1 = require("./form-controls");
var flight_reminder_1 = require("./flight-reminder");
exports.DECLARED_AND_EXPORTED_COMPONENTS = [
    traveler_details_1.TravelerDetailComponent,
    address_1.AddressComponent,
    trip_details_1.TripDatesComponent,
    trip_details_1.TripDestinationComponent,
    trip_details_1.TripProvidersComponent,
    trip_details_1.TripDetailsComponent,
    policy_details_1.PolicyEditDetailsComponent,
    coverages_1.IncludedCoverageComponent,
    coverages_1.OptionalCoverageComponent,
    date_pair_1.DatePairComponent,
    coverage_cart_1.QuoteSidebarComponent,
    custom_directives_1.FocusOnInitDirective,
    custom_directives_2.NumberOnlyDirective,
    item_selector_1.ItemSelectorComponent,
    payments_1.PaymentIFrameComponent,
];
exports.IMPORTED_AND_EXPORTED_MODULES = [
    flight_builder_1.BhtpFlightBuilderModule,
    masked_datepicker_1.BhtpMaskedDatePickerModule,
    validation_messages_1.BhtpValidationMessagesModule,
    error_message_display_1.BhtpErrorMessageDisplayModule,
    misc_1.BhtpMiscModule,
    form_controls_1.BhtpFormControlsModule,
    flight_reminder_1.BhtpFlightReminderModule
];
var BhtpComponentModule = BhtpComponentModule_1 = (function () {
    function BhtpComponentModule() {
    }
    BhtpComponentModule.forRoot = function () {
        return {
            ngModule: BhtpComponentModule_1
        };
    };
    return BhtpComponentModule;
}());
BhtpComponentModule = BhtpComponentModule_1 = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            ngx_bootstrap_1.TooltipModule.forRoot(),
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            eligibility_1.BhtpEligibilityModule,
            angular2_text_mask_1.TextMaskModule,
            type_ahead_1.BhtpTypeaheadModule.forRoot(),
            exports.IMPORTED_AND_EXPORTED_MODULES,
            ng_bootstrap_1.NgbModule
        ],
        declarations: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        exports: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS,
            exports.IMPORTED_AND_EXPORTED_MODULES,
            type_ahead_1.BhtpTypeaheadModule
        ],
        providers: [
            view_config_models_1.RulesService,
            view_config_models_2.CoverageFormService,
            payments_1.CardIFrameService
        ]
    })
], BhtpComponentModule);
exports.BhtpComponentModule = BhtpComponentModule;
var BhtpComponentModule_1;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/component.module.js